export enum BrandEnum {
    LowQuote = 1,
    Low = 2,
    Hello = 3,
    TrueWealth
}
